import React from 'react';
import { Modal, Text, Button, Link, Flex } from '@gr/ui-neo';
import { LockIcon } from './LockIcon';
export const LivechatNoAccess = ({ isOpen, onClose, triggerRef, cancelButtonText, description, title, upgradeButtonText, onUpgrade, customZIndex, }) => {
    const onCancel = React.useCallback((event) => {
        var _a;
        event.preventDefault();
        onClose();
        (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [onClose, triggerRef]);
    return (React.createElement(Modal, { closeButtonProps: {
            'data-ats-live-chat-no-access-button': 'close',
        }, triggerRef: triggerRef, size: "small", zIndex: customZIndex, isOpen: isOpen, onClose: onClose },
        React.createElement(Flex, { height: "100%", alignItems: "center", justifyContent: "center", flexDirection: "column" },
            React.createElement(LockIcon, null),
            React.createElement(Text, { color: "graphite", marginBottom: "sm", align: "center", variant: "header-2" }, title),
            React.createElement(Text, { color: "slathe", marginBottom: "base", align: "center", variant: "paragraph-large" }, description),
            React.createElement(Button, { onClick: onUpgrade, "data-ats-live-chat-no-access-button": "upgrade", size: "large", marginBottom: "md", variant: "upgrade" }, upgradeButtonText),
            React.createElement(Link, { "data-ats-live-chat-no-access-link": "maybe-later", href: "#", variant: "body-medium", onClick: onCancel, align: "center" }, cancelButtonText))));
};
